import { render, staticRenderFns } from "./Stick.vue?vue&type=template&id=39098f28&scoped=true&lang=html"
import script from "./Stick.vue?vue&type=script&lang=js"
export * from "./Stick.vue?vue&type=script&lang=js"
import style0 from "./Stick.vue?vue&type=style&index=0&id=39098f28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39098f28",
  null
  
)

export default component.exports